import { HorizontalScroll } from "../../utils/HorizontalScroll/index.js";
import {
  initLenisSmoothScroll,
  initCatchText,
} from "../../common/init/index.js";
// 页面初始化
document.addEventListener("DOMContentLoaded", async function () {
  try {
    // 初始化页面
    await initPage();
  } catch (error) {
    console.error("页面初始化失败:", error);
  }
});
/**
 * 初始化界面
 */
async function initPage() {
  if (typeof loadLibraries !== "undefined") {
    await loadLibraries(["gsap", "gsap-scrollTrigger"]);
    initOurProducts();
    initNumberCounter();
    initPageAnimation();
  }
  initPartnersMarquee();
  initCatchText();
  initLenisSmoothScroll();
}

/**
 * 初始化我们的产品（淡入淡出滚动）
 */
function initOurProducts() {
  const wrapper = document.querySelector(".our-products-wrapper");
  const items = document.querySelector(".our-products-items");

  if (!wrapper || !items) {
    return;
  }
  const progress = wrapper.querySelector(".our-product-progress");
  progress.classList.add("hidden");
  const horizontalScroll = new HorizontalScroll(wrapper, items, null, {
    fadeDuration: 0.6,
    fadeEase: "power2.inOut",
    on: {
      onLeave: () => {
        progress.classList.add("hidden");
      },
      onEnterBack: () => {
        progress.classList.remove("hidden");
      },
      onEnter: () => {
        progress.classList.remove("hidden");
      },
    },
    // distance: 3000,
  });
}

/**
 * 合作企业 Logo 走马灯（JS驱动，根据滚动方向加速/反向）
 */
function initPartnersMarquee() {
  const marquee = document.querySelector(".partners-section .logo-marquee");
  const track = document.querySelector(".partners-section .logo-track");
  if (!marquee || !track) return;

  // 若内容宽度不足，克隆子元素，保证无缝循环
  const ensureDuplicated = () => {
    const containerWidth = marquee.clientWidth;
    let contentWidth = track.scrollWidth;
    if (contentWidth < containerWidth * 2) {
      const children = Array.from(track.children);
      // 最多克隆一次全量，避免无限增长
      children.forEach((child) => track.appendChild(child.cloneNode(true)));
      contentWidth = track.scrollWidth;
    }
    return contentWidth;
  };

  let contentWidth = ensureDuplicated();
  let halfWidth = contentWidth / 2;

  // 位置与速度（px / frame）
  let posX = 0;
  const baseSpeed = 0.5; // 基础速度
  const defaultVelocity = -0.5; // 默认向左匀速
  let velocity = defaultVelocity;
  let targetVelocity = defaultVelocity;

  // 根据滚动方向/强度调整速度与方向
  const accelFactor = 0.25; // 将滚动的 delta 转换为速度的比例（加快）
  let lastWheelTime = 0;

  const onWheel = (e) => {
    // 仅当向下滚动时加速（加速向左移动）
    const magnitude = Math.min(Math.abs(e.deltaY), 200);
    if (e.deltaY > 0) {
      targetVelocity = -(baseSpeed + magnitude * accelFactor); // 更负 → 更快向左
      lastWheelTime = performance.now();
    }
  };

  // 作为补充：根据 scrollY 的变化判断方向（触控或键盘）
  let lastScrollY = window.scrollY;
  const onScroll = () => {
    const nowY = window.scrollY;
    const dy = nowY - lastScrollY;
    lastScrollY = nowY;
    if (dy <= 0) return; // 只处理向下滚动
    const magnitude = Math.min(Math.abs(dy), 200);
    targetVelocity = -(baseSpeed + magnitude * accelFactor); // 更负 → 更快向左
    lastWheelTime = performance.now();
  };

  window.addEventListener("wheel", onWheel, { passive: true });
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => {
    // 尺寸变化时重新校验内容长度
    contentWidth = ensureDuplicated();
    halfWidth = contentWidth / 2;
  });

  const tick = () => {
    // 当最近一段时间没有滚动输入时，缓慢回归默认速度与方向
    const now = performance.now();
    if (now - lastWheelTime > 500) {
      targetVelocity += (defaultVelocity - targetVelocity) * 0.05; // 更快回归
    }

    // 速度缓动至目标速度（提高响应速度）
    velocity += (targetVelocity - velocity) * 0.12;

    // 更新位置
    posX += velocity;

    // 无缝循环（双向支持）
    if (posX <= -halfWidth) {
      posX += halfWidth;
    } else if (posX >= 0) {
      posX -= halfWidth;
    }

    // 应用位移
    track.style.transform = `translateX(${posX}px)`;

    requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
}

function initNumberCounter() {
  // 数字计数器
  const counters = document.querySelectorAll("count-down[data-to]");
  counters.forEach((el) => {
    const target = parseFloat(el.getAttribute("data-to") || "0");
    const obj = { val: 0 };
    gsap.to(obj, {
      val: target,
      duration: 1.2,
      ease: "power1.out",
      onUpdate: () => {
        const isInt = Number.isInteger(target);
        el.textContent = isInt ? Math.round(obj.val) : obj.val.toFixed(1);
      },
      scrollTrigger:
        typeof ScrollTrigger !== "undefined"
          ? {
              trigger: el,
              start: "top 90%",
              toggleActions: "play none none reverse",
            }
          : undefined,
    });
  });
}

/**
 * 初始化页面动画
 */
function initPageAnimation() {
  a_AboutUs();
  a_OurProduct();
  a_OurProductTitle();
  a_AfterService();
}

function a_AboutUs() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    return;
  }
  if (typeof gsap.registerPlugin === "function") {
    gsap.registerPlugin(ScrollTrigger);
  }
  const aboutSection = document.querySelector(".about-us-section");
  if (!aboutSection) return;

  const animateTargets = gsap.utils.toArray(
    aboutSection.querySelectorAll(".about-animate")
  );
  if (animateTargets.length) {
    gsap.set(animateTargets, { autoAlpha: 0, y: 60 });
    ScrollTrigger.create({
      trigger: aboutSection,
      start: "top 50%",
      once: true,
      onEnter: () => {
        gsap.to(animateTargets, {
          autoAlpha: 1,
          y: 0,
          duration: 0.9,
          ease: "power3.out",
          stagger: 0.12,
        });
      },
    });
  }

  const title = aboutSection.querySelector(".text-catch");
  if (title) {
    ScrollTrigger.create({
      trigger: title,
      start: "top 50%",
      once: true,
      onEnter: () => title.classList.add("animate"),
    });
  }
}

function a_OurProductTitle() {
  const title = document.querySelector(".our-products-title-section");
  if (!title) return;
  const h2 = title.querySelector("h2");
  const desc = title.querySelector(".our-products-right__desc");
  const h3 = desc.querySelector("h3");
  const pList = desc.querySelectorAll("p");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          [h2, h3, ...pList].forEach((dom, index) => {
            setTimeout(() => {
              dom.classList.add("animate");
            }, 200 * index);
          });
        }
      });
    },
    {
      root: null, // 视口
      threshold: 0.1, // 元素10%显示时即算进入
    }
  );
  observer.observe(title);
}

function a_OurProduct() {
  const ourProductBanner = document.querySelector("#our-products-banner");
  if (ourProductBanner) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const textList = ourProductBanner.querySelectorAll("p.text-catch");
            textList.forEach((text) => {
              text.classList.add("animate");
            });
            observer.disconnect();
          }
        });
      },
      {
        root: null, // 视口
        threshold: 0.5, // 元素50%显示时即算进入
      }
    );
    observer.observe(ourProductBanner);
  }
}

/**
 * 初始化售后服务流程&保障动画（从右往左出现）
 */
function a_AfterService() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    return;
  }
  if (typeof gsap.registerPlugin === "function") {
    gsap.registerPlugin(ScrollTrigger);
  }
  const afterServiceSection = document.querySelector(".after-service-section");
  if (!afterServiceSection) return;

  const animateTargets = gsap.utils.toArray(
    afterServiceSection.querySelectorAll(".service-animate")
  );
  if (animateTargets.length) {
    // 设置初始状态：从右侧（x: 100）且透明
    gsap.set(animateTargets, { autoAlpha: 0, x: 100 });
    gsap.to(animateTargets, {
      autoAlpha: 1,
      x: 0,
      duration: 0.8,
      ease: "power3.out",
      stagger: 0.15, // 每个卡片延迟0.15秒，形成依次出现的效果
      scrollTrigger: {
        trigger: afterServiceSection,
        start: "top 30%",
        once: true,
      },
    });
  }
}
